import { useCallback, useMemo } from 'react';
import useAuth from './useAuth';

/**
 * Permissions de l'utilisateur connecté.
 *
 * `can(key, fallback)` : vrai si l'utilisateur a la permission `key`
 * (catalogue : php/App/Permission/PermissionCatalog.php).
 *
 * `fallback` n'est utilisé que si l'API ne renvoie pas encore de permissions
 * (front déployé avant le back) : on garde alors l'ancienne règle en dur,
 * pour que rien ne change tant que le back n'est pas à jour. Une fois le back
 * déployé, les permissions sont TOUJOURS présentes — calculées depuis le
 * profil historique si l'utilisateur n'a pas de rôle.
 */
const usePermissions = () => {
  const { user } = useAuth();
  const permissions = user?.permissions;
  const ready = Array.isArray(permissions);

  const set = useMemo(() => new Set(ready ? permissions : []), [ready, permissions]);

  const can = useCallback(
    (key, fallback = false) => (ready ? set.has(key) : Boolean(fallback)),
    [ready, set]
  );

  return {
    ready,
    can,
    role: user?.role ?? null,
    isSuperAdmin: Boolean(user?.role?.is_super)
  };
};

export default usePermissions;
